import { Controller } from "@hotwired/stimulus"

// Must run before Alpine boots (CDN is defer; this pack is not). The TYPE
// funnel menu shows via $store.bcFilters.openColumn — without the store the
// click is a no-op / TypeError.
document.addEventListener("alpine:init", () => {
  if (window.Alpine.store("bcFilters") === undefined) {
    window.Alpine.store("bcFilters", { openColumn: null })
  }
})

// Lists index filters: TYPE column funnel + workspace select share one POST.
// column_filter_menu still calls window.filterApply — we own that while mounted.
export default class extends Controller {
  static values = {
    applyUrl: String,
    workspace: { type: String, default: "" }
  }

  connect() {
    this.ensureFiltersStore()
    this.previousFilterApply = window.filterApply
    this.boundApply = (data) => this.apply(data)
    window.filterApply = this.boundApply
  }

  disconnect() {
    if (window.filterApply === this.boundApply) {
      window.filterApply = this.previousFilterApply
    }
  }

  workspaceChanged(event) {
    if (event.detail?.name !== "list_workspace") return

    this.workspaceValue = event.detail.value || ""
    const url = new URL(window.location.href)
    url.searchParams.delete("page")
    url.searchParams.delete("workspace_uuid")
    if (this.workspaceValue) url.searchParams.set("workspace_uuid", this.workspaceValue)
    window.history.replaceState({}, "", url.toString())
    this.apply({ column: null, selectedValues: [] })
  }

  apply(overrideData = {}) {
    const urlParams = this.filterParams(overrideData)
    const body = new FormData()
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    if (token) body.append("authenticity_token", token)
    for (const [key, value] of urlParams.entries()) body.append(key, value)

    window.history.replaceState({}, "", `${window.location.pathname}?${urlParams}`)
    fetch(this.applyUrlValue, {
      method: "POST",
      body,
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html))
  }

  filterParams(overrideData = {}) {
    const params = new URLSearchParams()
    const current = new URLSearchParams(window.location.search)
    const search = current.get("search")
    const items = current.get("items")
    if (search) params.set("search", search)
    if (items) params.set("items", items)
    if (this.workspaceValue) params.set("workspace_uuid", this.workspaceValue)

    document.querySelectorAll('[id^="filter-"]').forEach((filterEl) => {
      try {
        const elData = window.Alpine?.$data(filterEl)
        if (!elData || elData.selectedValues === undefined) return

        const col = filterEl.id.replace("filter-", "")
        const values = overrideData.column === col
          ? overrideData.selectedValues
          : elData.selectedValues
        if (values?.length > 0) params.set(col, values.join(","))
      } catch (_error) {
        // Alpine may not be bound yet after a turbo replace.
      }
    })

    return params
  }

  ensureFiltersStore() {
    if (!window.Alpine?.store) return
    if (window.Alpine.store("bcFilters") === undefined) {
      window.Alpine.store("bcFilters", { openColumn: null })
    }
  }
}
